import React from 'react'
import ProfileMenu from './ProfileMenu'
import './style.scss'

class TopBar extends React.Component {
  render() {
    return (
      <div className="topbar">
        <img
          src="resources/quqoImages/logoQ.png"
          rel="noopener noreferrer"
          alt="Mediatec Software"
          className="quqoImageHeader"
        />
        <img
          src="resources/quqoImages/corbetaLogo.PNG"
          rel="noopener noreferrer"
          alt="Mediatec Software"
          className="corbetaImageHeader"
        />
        <div className="topbar__right">
          <strong className="topbar__nameUser">Corbeta administrador</strong>&nbsp;
          <ProfileMenu />
        </div>
      </div>
    )
  }
}

export default TopBar



// WEBPACK FOOTER //
// ./src/components/LayoutComponents/TopBar/index.js